export default function Home() {
  return (
    <div>
      <h1>Generate quick links to teleport you in-sim.</h1>
      <p>we aren't on a fun url, include a download link</p>
    </div>
  );
}
